export enum Routes {
  Home = "/",
  Login = "/login",
  Users = "/users",
}
